import React, {useRef} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Tooltip} from '@optimaxdev/design-system';
import {Icon, Question} from '@optimaxdev/icons';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import AmericanExpressIcon from 'components/img/americanExpress.svg';
import VisaIcon from 'components/img/visa.svg';
import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

import s from './paymentCvvTooltip.scss';

/**
 * Payment cvv tooltip for checkout
 *
 * @constructor
 */
export const PaymentCvvTooltip: React.FC = () => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const viewed = useRef<boolean>(false);
    const onHover = (isVisible: boolean) => {
        if (!viewed.current && isVisible) {
            sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
                message: 'CVV/CID - Learn More - Hover',
                method: 'Payment',
            });
            viewed.current = true;
        }
    };
    return (
        <div className={classNames(s.wrapQuestionMark, {[s.wrapQuestionMarkFaceLift]: isFacelift})}>
            <Tooltip
                content={
                    <div className={s.tooltip}>
                        <div className={s.icons}>
                            <VisaIcon className={s.visa} />
                            <AmericanExpressIcon />
                        </div>
                        <p className={s.text}>
                            Please enter your card security code. It is a 3-digit number usually
                            found
                            <br /> on the back of your card. American Express cards have a 4-digit
                            code
                            <br /> on the front.
                        </p>
                    </div>
                }
                closeTrigger="hover"
                offset={23}
                onVisibilityChanged={onHover}
                openTrigger="hover"
                position="top-end"
                isHideOnScroll
            >
                <Icon className={s.icon} icon={Question} />
            </Tooltip>
        </div>
    );
};
